// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
// If you deleted src/index.css, remove or ensure it's appropriately styled
import './styles/tokens.css';
import './index.css'; // create-react-app provides some base styling here
import './i18n';
import App from './App';
// import reportWebVitals from './reportWebVitals'; // You can remove this if you deleted the file

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(); // You can remove this if you deleted the file
